// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `p, h1 {
  margin: 0;
}

.price {
  padding: 30px 100px;
  text-align: center;
}

.price h1 {
  font-size: 47.78px;
  font-weight: 900 !important;
}

.Enhanced .button-no-bg,
.Enhanced .Enhanced-btn {
  padding: 14px 24px;
}

.price .price-top {
  display: flex;
  justify-content: center;
  text-align: center;
  align-items: center;
  gap: 15px;
    margin: 25px 0;
}

.price-top p.active {
  font-weight: bolder;
  color: #262626;
}

.price-top p {
  font-size: 19.2px;
  color: #5c5c5c;
}

.pricing-tab {
  width: 100%;
  margin-top: 20px;


}

.pricing-tab ul {
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: center;
}

.pricing-tab ul li {
  list-style: none;
  font-weight: 500;
  font-size: 18px;
  padding: 5px 0;
  margin: 0px 25px;
  color: #878395;
  cursor: pointer;
}

.pricing-tab ul li.active {
  border-top: 3px solid rgba(108, 47, 187, 1);
  color: rgba(108, 47, 187, 1);
}

.price-sidebar {
  position: sticky;
  top: 100px;
  text-align: left;
}

.price-sidebar button {
  width: 100%;
  height: 45px;
  display: flex;
  align-items: center;
  border: none;
  outline: none;
  background: transparent;
  border-radius: 8px;
  padding: 0 10px;
  font-weight: 400;
  margin-top: 2px;
  text-align: left;
}

.price-sidebar button:hover {
  background-color: rgba(122, 45, 249, 0.1);
  color: #6c2fbb;
  font-weight: 500;
}

.price-sidebar button.active {
  background-color: rgba(122, 45, 249, 0.1);
  color: #6c2fbb;
  font-weight: 500;
}

@media (max-width: 1500px) {
  .price-top p b {
    font-size: 19.2px;
    color: #000;
    font-weight: 700;
  }

  .price-top p {
    font-size: 19.2px;
    color: #5c5c5c;
    font-weight: 400;
  }

  .switch {
    height: 29px !important;
  }
}

.price-top .save {
  border: none;
  outline: none;
  background: #fae267;
  border-radius: 4px;
  color: #000;
  font-weight: 700;
  font-size: 14px;
  font-weight: bold;
  padding: 4px 12px;
}

.price .price-card .card {
  text-align: start;
  padding: 25px;
  border-radius: 15px;
  height: 100%;
  box-shadow: 0px 1px 15px rgba(152, 152, 152, 0.15);
  border: 2px solid #ffffff;
  padding-bottom: 10px;
}

.border-active {
  border: 2px solid #6438b4 !important;
}

.price .price-card .card h4 {
  font-weight: bold;
  font-size: 19.2px;
  color: #5c5c5c;
}

.price .price-card .card .month div {
  display: flex !important;
  align-items: center;
  margin: 20px 0;
}

.price .price-card .card .d-flex {
  align-items: center;
}

.price .price-top .Popular {
  background: #e1e1f9;
  border-radius: 20px;
  border: none;
  outline: none;
  color: #6438b4;
  padding: 5px 15px;
  margin: 0 10px;
  font-weight: bold;
  font-size: 16px;
}

.price .price-card .card .Popular {
  background: #e1e1f9;
  border-radius: 20px;
  border: none;
  outline: none;
  color: #6438b4;
  padding: 5px 15px;
  margin: 0 10px;
  font-weight: bold;
  font-size: 14px;
}

.price .price-card .card .month span {
  font-weight: 400;
  font-size: 14px;
  color: #5c5c5c;
  margin-left: 10px;
}

.price .price-card .card .individual {
  font-weight: 400;
  font-size: 14px;
  color: #5c5c5c;
  min-height: 42px;
}

.price-content {
    /*padding: 12px 0;*/
}

.price-content img {
  width: 30px;
}

.price-line {
    /*padding: 15px 0px 10px 0;*/
  border-bottom: 1px solid #d9d9d9;
}

.price .price-card .card .admin {
  display: flex;
  align-items: center;
    margin: 12px 0;
  justify-content: space-between;
}

.price .price-card .card .admin div {
  display: flex;
  font-size: 18px;
}

.price .price-card .card .admin div p {
  margin: 0px 10px;
  color: #262626;
  font-size: 16px;
}

.price .price-card .card .admin img {
  width: 20px;
  object-fit: contain;
}

.price .price-card .card .price-content div {
    align-items: center;
  display: flex;
  gap: 10px;
    margin: 12px 0;
}

.price .price-card .card .price-content div p {
  font-size: 16px;
  color: #262626;
}

.price .price-card .card .price-content .gry-color p {
  color: #5c5c5c;
}

.price .price-card .card .price-btn {
  font-style: normal;
  font-weight: 700 !important;
  font-size: 16px;
  border: 2px solid #6438B4;
  padding: 16px 24px;
    /*margin-top: 20px;*/
  border-radius: 5px;
  margin: 5px 0 15px 0;
    /*font-weight: bold;*/
  background-color: transparent;
  color: #6438B4;
    margin-top: auto;
}

.price .price-card .border-active.card .btn-bg {
  background: #6438b4;
  color: #fff;
}

label {
  margin-bottom: 0 !important;
}

.price .price-card .card h1 {
  font-size: 57.33px;
}

@media (max-width: 1500px) {
  .price h1 {
    font-size: 47.78px;
    line-height: 140%;
  }

  .price .price-top {
    margin: 20px auto 70px auto;
  }
}

@media (max-width: 1200px) {
  .price .price-card .col-lg-4 {
    margin: 20px 0 !important;
  }
}

@media (max-width: 1500px) {
  .price .price-card .card h4 {
    font-weight: 700;
    font-size: 19.2px;
    line-height: 140%;
  }

  .price {
    padding: 40px 35px;
  }

  .price .price-card .card h1 {
    font-weight: 900;
    font-size: 57.33px;
    line-height: 140%;
  }

  .price .price-card .card .month span {
    font-weight: 400;
    font-size: 14px;
    line-height: 140%;
  }

  .price .price-card .card .individual {
    font-weight: 400;
    font-size: 15px;
    line-height: 140%;
  }
}

@media (max-width: 1300px) {
  .price .price-card .card h4 {
    font-size: 18px;
  }

  .price .price-card .card h1 {
    font-size: 35px !important;
  }

  .price .price-card .card .individual {
    font-size: 16px;
  }

  .price .price-card .card {
    padding: 17px;
  }

  .price .price-card .card .month span,
  .price .price-card .card .price-content div p,
  .price .price-card .card .admin div {
    font-size: 16px;
  }

  .price .price-card .card .admin div p {
    font-weight: 400;
    font-size: 16px;
    line-height: 150%;
  }
}

label {
  margin-bottom: 0;
}

@media (max-width: 991px) {
  .price h1 {
    font-size: 40px;
  }
}

@media (max-width: 768px) {
  .price-top p b {
    font-size: 18px;
  }

  .price-top p {
    font-size: 18px;
  }

  .price-top .save {
    padding: 2px 6px;
    font-size: 15px;
  }

  .price .price-top {
    margin: 20px auto 40px auto !important;
  }
}

@media (max-width: 420px) {
  .price {
    padding: 40px 10px;
  }

  .price h1 {
    font-size: 42px;
    line-height: 50px;
  }

  .price .price-card {
    margin-top: 20px !important;
  }

  .price .price-top {
    margin: 20px auto 10px auto !important;
  }

  .switch {
    width: 43px !important;
    height: 23px !important;
  }

  .slider:before {
    width: 17px !important;
    height: 17px !important;
  }

  .price-top p b {
    font-size: 16px;
  }

  .price-top p {
    font-size: 16px;
  }

  .price .price-card .card .price-btn {
    padding: 7px 0;
  }
}


.switch {
  position: relative;
  display: inline-block;
  width: 55px;
  height: 29px;
}

.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: #d9d9d9;
  -webkit-transition: 0.4s;

  transform: translate(0px, 0px);
  transition: 0.6s ease transform, 0.6s box-shadow;
}

.slider:before {
  position: absolute;
  content: "";
  height: 22px;
  width: 22px;
  left: 4px;
  bottom: 4px;
  background-color: white;
  transition: 0.4s;
}

input:checked + .slider {
  background: #6438b4;
}

input:focus + .slider {
  box-shadow: 0 0 1px #50bfe6;
}

input:checked + .slider:before {
  transform: translateX(26px);
}

.slider.round {
  border-radius: 34px;
}

.slider.round:before {
  border-radius: 50%;
}
`, "",{"version":3,"sources":["webpack://./src/app/pages/pricing/pricing.component.css"],"names":[],"mappings":"AAAA;EACE,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,kBAAkB;EAClB,mBAAmB;EACnB,SAAS;IACP,cAAc;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,gBAAgB;;;AAGlB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,2CAA2C;EAC3C,4BAA4B;AAC9B;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,yCAAyC;EACzC,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,yCAAyC;EACzC,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE;IACE,iBAAiB;IACjB,WAAW;IACX,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;IACjB,cAAc;IACd,gBAAgB;EAClB;;EAEA;IACE,uBAAuB;EACzB;AACF;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,kDAAkD;EAClD,yBAAyB;EACzB,oBAAoB;AACtB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,wBAAwB;EACxB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;EACZ,aAAa;EACb,cAAc;EACd,iBAAiB;EACjB,cAAc;EACd,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;EACZ,aAAa;EACb,cAAc;EACd,iBAAiB;EACjB,cAAc;EACd,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;EACE,WAAW;AACb;;AAEA;IACI,4BAA4B;EAC9B,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,mBAAmB;IACjB,cAAc;EAChB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;IACI,mBAAmB;EACrB,aAAa;EACb,SAAS;IACP,cAAc;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,2BAA2B;EAC3B,eAAe;EACf,yBAAyB;EACzB,kBAAkB;IAChB,oBAAoB;EACtB,kBAAkB;EAClB,oBAAoB;IAClB,qBAAqB;EACvB,6BAA6B;EAC7B,cAAc;IACZ,gBAAgB;AACpB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE;IACE,kBAAkB;IAClB,iBAAiB;EACnB;;EAEA;IACE,2BAA2B;EAC7B;AACF;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE;IACE,gBAAgB;IAChB,iBAAiB;IACjB,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;IAChB,kBAAkB;IAClB,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;IAChB,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;IAChB,eAAe;IACf,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;;;IAGE,eAAe;EACjB;;EAEA;IACE,gBAAgB;IAChB,eAAe;IACf,iBAAiB;EACnB;AACF;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,sCAAsC;EACxC;AACF;;AAEA;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,sCAAsC;EACxC;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,cAAc;EAChB;AACF;;;AAGA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,UAAU;EACV,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,mBAAmB;EACnB,wBAAwB;;EAExB,8BAA8B;EAC9B,gDAAgD;AAClD;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,WAAW;EACX,SAAS;EACT,WAAW;EACX,uBAAuB;EAEvB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EAGE,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB","sourcesContent":["p, h1 {\n  margin: 0;\n}\n\n.price {\n  padding: 30px 100px;\n  text-align: center;\n}\n\n.price h1 {\n  font-size: 47.78px;\n  font-weight: 900 !important;\n}\n\n.Enhanced .button-no-bg,\n.Enhanced .Enhanced-btn {\n  padding: 14px 24px;\n}\n\n.price .price-top {\n  display: flex;\n  justify-content: center;\n  text-align: center;\n  align-items: center;\n  gap: 15px;\n    margin: 25px 0;\n}\n\n.price-top p.active {\n  font-weight: bolder;\n  color: #262626;\n}\n\n.price-top p {\n  font-size: 19.2px;\n  color: #5c5c5c;\n}\n\n.pricing-tab {\n  width: 100%;\n  margin-top: 20px;\n\n\n}\n\n.pricing-tab ul {\n  display: flex;\n  width: 100%;\n  align-items: center;\n  justify-content: center;\n}\n\n.pricing-tab ul li {\n  list-style: none;\n  font-weight: 500;\n  font-size: 18px;\n  padding: 5px 0;\n  margin: 0px 25px;\n  color: #878395;\n  cursor: pointer;\n}\n\n.pricing-tab ul li.active {\n  border-top: 3px solid rgba(108, 47, 187, 1);\n  color: rgba(108, 47, 187, 1);\n}\n\n.price-sidebar {\n  position: sticky;\n  top: 100px;\n  text-align: left;\n}\n\n.price-sidebar button {\n  width: 100%;\n  height: 45px;\n  display: flex;\n  align-items: center;\n  border: none;\n  outline: none;\n  background: transparent;\n  border-radius: 8px;\n  padding: 0 10px;\n  font-weight: 400;\n  margin-top: 2px;\n  text-align: left;\n}\n\n.price-sidebar button:hover {\n  background-color: rgba(122, 45, 249, 0.1);\n  color: #6c2fbb;\n  font-weight: 500;\n}\n\n.price-sidebar button.active {\n  background-color: rgba(122, 45, 249, 0.1);\n  color: #6c2fbb;\n  font-weight: 500;\n}\n\n@media (max-width: 1500px) {\n  .price-top p b {\n    font-size: 19.2px;\n    color: #000;\n    font-weight: 700;\n  }\n\n  .price-top p {\n    font-size: 19.2px;\n    color: #5c5c5c;\n    font-weight: 400;\n  }\n\n  .switch {\n    height: 29px !important;\n  }\n}\n\n.price-top .save {\n  border: none;\n  outline: none;\n  background: #fae267;\n  border-radius: 4px;\n  color: #000;\n  font-weight: 700;\n  font-size: 14px;\n  font-weight: bold;\n  padding: 4px 12px;\n}\n\n.price .price-card .card {\n  text-align: start;\n  padding: 25px;\n  border-radius: 15px;\n  height: 100%;\n  box-shadow: 0px 1px 15px rgba(152, 152, 152, 0.15);\n  border: 2px solid #ffffff;\n  padding-bottom: 10px;\n}\n\n.border-active {\n  border: 2px solid #6438b4 !important;\n}\n\n.price .price-card .card h4 {\n  font-weight: bold;\n  font-size: 19.2px;\n  color: #5c5c5c;\n}\n\n.price .price-card .card .month div {\n  display: flex !important;\n  align-items: center;\n  margin: 20px 0;\n}\n\n.price .price-card .card .d-flex {\n  align-items: center;\n}\n\n.price .price-top .Popular {\n  background: #e1e1f9;\n  border-radius: 20px;\n  border: none;\n  outline: none;\n  color: #6438b4;\n  padding: 5px 15px;\n  margin: 0 10px;\n  font-weight: bold;\n  font-size: 16px;\n}\n\n.price .price-card .card .Popular {\n  background: #e1e1f9;\n  border-radius: 20px;\n  border: none;\n  outline: none;\n  color: #6438b4;\n  padding: 5px 15px;\n  margin: 0 10px;\n  font-weight: bold;\n  font-size: 14px;\n}\n\n.price .price-card .card .month span {\n  font-weight: 400;\n  font-size: 14px;\n  color: #5c5c5c;\n  margin-left: 10px;\n}\n\n.price .price-card .card .individual {\n  font-weight: 400;\n  font-size: 14px;\n  color: #5c5c5c;\n  min-height: 42px;\n}\n\n.price-content {\n    /*padding: 12px 0;*/\n}\n\n.price-content img {\n  width: 30px;\n}\n\n.price-line {\n    /*padding: 15px 0px 10px 0;*/\n  border-bottom: 1px solid #d9d9d9;\n}\n\n.price .price-card .card .admin {\n  display: flex;\n  align-items: center;\n    margin: 12px 0;\n  justify-content: space-between;\n}\n\n.price .price-card .card .admin div {\n  display: flex;\n  font-size: 18px;\n}\n\n.price .price-card .card .admin div p {\n  margin: 0px 10px;\n  color: #262626;\n  font-size: 16px;\n}\n\n.price .price-card .card .admin img {\n  width: 20px;\n  object-fit: contain;\n}\n\n.price .price-card .card .price-content div {\n    align-items: center;\n  display: flex;\n  gap: 10px;\n    margin: 12px 0;\n}\n\n.price .price-card .card .price-content div p {\n  font-size: 16px;\n  color: #262626;\n}\n\n.price .price-card .card .price-content .gry-color p {\n  color: #5c5c5c;\n}\n\n.price .price-card .card .price-btn {\n  font-style: normal;\n  font-weight: 700 !important;\n  font-size: 16px;\n  border: 2px solid #6438B4;\n  padding: 16px 24px;\n    /*margin-top: 20px;*/\n  border-radius: 5px;\n  margin: 5px 0 15px 0;\n    /*font-weight: bold;*/\n  background-color: transparent;\n  color: #6438B4;\n    margin-top: auto;\n}\n\n.price .price-card .border-active.card .btn-bg {\n  background: #6438b4;\n  color: #fff;\n}\n\nlabel {\n  margin-bottom: 0 !important;\n}\n\n.price .price-card .card h1 {\n  font-size: 57.33px;\n}\n\n@media (max-width: 1500px) {\n  .price h1 {\n    font-size: 47.78px;\n    line-height: 140%;\n  }\n\n  .price .price-top {\n    margin: 20px auto 70px auto;\n  }\n}\n\n@media (max-width: 1200px) {\n  .price .price-card .col-lg-4 {\n    margin: 20px 0 !important;\n  }\n}\n\n@media (max-width: 1500px) {\n  .price .price-card .card h4 {\n    font-weight: 700;\n    font-size: 19.2px;\n    line-height: 140%;\n  }\n\n  .price {\n    padding: 40px 35px;\n  }\n\n  .price .price-card .card h1 {\n    font-weight: 900;\n    font-size: 57.33px;\n    line-height: 140%;\n  }\n\n  .price .price-card .card .month span {\n    font-weight: 400;\n    font-size: 14px;\n    line-height: 140%;\n  }\n\n  .price .price-card .card .individual {\n    font-weight: 400;\n    font-size: 15px;\n    line-height: 140%;\n  }\n}\n\n@media (max-width: 1300px) {\n  .price .price-card .card h4 {\n    font-size: 18px;\n  }\n\n  .price .price-card .card h1 {\n    font-size: 35px !important;\n  }\n\n  .price .price-card .card .individual {\n    font-size: 16px;\n  }\n\n  .price .price-card .card {\n    padding: 17px;\n  }\n\n  .price .price-card .card .month span,\n  .price .price-card .card .price-content div p,\n  .price .price-card .card .admin div {\n    font-size: 16px;\n  }\n\n  .price .price-card .card .admin div p {\n    font-weight: 400;\n    font-size: 16px;\n    line-height: 150%;\n  }\n}\n\nlabel {\n  margin-bottom: 0;\n}\n\n@media (max-width: 991px) {\n  .price h1 {\n    font-size: 40px;\n  }\n}\n\n@media (max-width: 768px) {\n  .price-top p b {\n    font-size: 18px;\n  }\n\n  .price-top p {\n    font-size: 18px;\n  }\n\n  .price-top .save {\n    padding: 2px 6px;\n    font-size: 15px;\n  }\n\n  .price .price-top {\n    margin: 20px auto 40px auto !important;\n  }\n}\n\n@media (max-width: 420px) {\n  .price {\n    padding: 40px 10px;\n  }\n\n  .price h1 {\n    font-size: 42px;\n    line-height: 50px;\n  }\n\n  .price .price-card {\n    margin-top: 20px !important;\n  }\n\n  .price .price-top {\n    margin: 20px auto 10px auto !important;\n  }\n\n  .switch {\n    width: 43px !important;\n    height: 23px !important;\n  }\n\n  .slider:before {\n    width: 17px !important;\n    height: 17px !important;\n  }\n\n  .price-top p b {\n    font-size: 16px;\n  }\n\n  .price-top p {\n    font-size: 16px;\n  }\n\n  .price .price-card .card .price-btn {\n    padding: 7px 0;\n  }\n}\n\n\n.switch {\n  position: relative;\n  display: inline-block;\n  width: 55px;\n  height: 29px;\n}\n\n.switch input {\n  opacity: 0;\n  width: 0;\n  height: 0;\n}\n\n.slider {\n  position: absolute;\n  cursor: pointer;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: #d9d9d9;\n  -webkit-transition: 0.4s;\n\n  transform: translate(0px, 0px);\n  transition: 0.6s ease transform, 0.6s box-shadow;\n}\n\n.slider:before {\n  position: absolute;\n  content: \"\";\n  height: 22px;\n  width: 22px;\n  left: 4px;\n  bottom: 4px;\n  background-color: white;\n  -webkit-transition: 0.4s;\n  transition: 0.4s;\n}\n\ninput:checked + .slider {\n  background: #6438b4;\n}\n\ninput:focus + .slider {\n  box-shadow: 0 0 1px #50bfe6;\n}\n\ninput:checked + .slider:before {\n  -webkit-transform: translateX(26px);\n  -ms-transform: translateX(26px);\n  transform: translateX(26px);\n}\n\n.slider.round {\n  border-radius: 34px;\n}\n\n.slider.round:before {\n  border-radius: 50%;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
